<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="850px"
    :title="titleName + '表单'"
    :visible.sync="dialogFormVisible"
    @opened="opened"
  >
    <el-form :model="form" :rules="formRules" ref="form">
      <el-form-item label="状态" :label-width="formLabelWidth" prop="status">
        <el-select
          class="search-select"
          v-model="form.status"
          placeholder="请选择状态"
          @change="changeRole"
        >
          <el-option
            v-for="(item, index) in rolesList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="标题" :label-width="formLabelWidth" prop="title">
        <el-input v-model="form.title" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="内容" :label-width="formLabelWidth" prop="content">
        <div class="toolbar"></div>
        <div class="content"></div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveBtn">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import wangeditor from 'wangeditor';
import {
  addSysMsgApi,
  getSysMsgContentApi,
  setSysMsgApi,
} from '@/api/newsApi.js';
export default {
  name: 'adminMsgForm',
  data() {
    return {
      formLabelWidth: '80px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      form: {
        content: '',
        title: '',
        status: '',
      },

      statuName: '',
      titleName: '新增',
      rolesList: [
        { label: '编辑中', value: 1 },
        { label: '已发布', value: 2 },
        { label: '已删除', value: 3 },
      ],
      editor: undefined, // 编辑器
      formRules: {
        title: [
          {
            required: true,
            message: '标题不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        content: [
          {
            required: true,
            message: '内容不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
            trigger: ['blur', 'change'],
          },
        ],
      },
    };
  },
  methods: {
    opened() {
      this.$nextTick(() => {
        // 楼盘特色
        if (this.editor === undefined) {
          this.editor = new wangeditor('.toolbar', '.content');
          this.editor.config.onchange = (html) => {
            this.form.content = html;
          };
          // 下面两个配置，使用其中一个即可显示“上传图片”的tab。但是两者不要同时使用！！！
          // this.editor.config.uploadImgShowBase64 = true; // 使用 base64 保存图片
          this.editor.config.uploadFileName = 'file'; // 上传参数
          this.editor.config.uploadImgServer = `${window.RequestUrl}/upload/images/photo`; // 上传图片到服务器
          // create方法
          this.editor.create();

          // 上传图片 insertImgFn
          this.editor.config.uploadImgHooks = {
            // 图片上传并返回了结果，图片插入已成功
            success(xhr) {
              console.log('success', xhr);
            },
            // 图片上传并返回了结果，但图片插入时出错了
            fail(xhr, editor, resData) {
              console.log('fail', resData);
            },
            // 上传图片出错，一般为 http 请求的错误
            error(xhr, editor, resData) {
              console.log('error', xhr, resData);
            },
            // 上传图片超时
            timeout(xhr) {
              console.log('timeout', xhr);
            },
            // 图片上传并返回了结果，想要自己把图片插入到编辑器中
            // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
            customInsert(insertImgFn, result) {
              // result 即服务端返回的接口
              // console.log('customInsert', result);
              if (result.code == 200) {
                // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
                insertImgFn(result.data);
              } else {
                this.$message.error('服务器出错');
              }
            },
          };
        }
        this.editor.txt.html(this.form.content);
        if (this.titleName === '编辑') this.getContent();
      });
    },

    // 获取内容信息
    async getContent() {
      try {
        let res = await getSysMsgContentApi(this.form.sysMsgId);
        this.form.content = res.data.content;
        this.editor.txt.html(res.data.content);
      } catch (e) {
        window.console.log(e);
      }
    },

    // 保存
    saveBtn() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        let dateNotes = this.$moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');
        if (this.titleName === '新增') {
          this.add(dateNotes);
        } else {
          this.edit(dateNotes);
        }
      });
    },

    // 新增
    async add(dateNotes) {
      try {
        let data =
          'content=' +
          this.form.content +
          '&status=' +
          this.form.status +
          '&title=' +
          this.form.title +
          '&dateNotes=' +
          dateNotes;
        let res = await addSysMsgApi(data);
        if (res.code !== 200) return;
        this.$message.success(this.titleName + '成功!');
        this.dialogFormVisible = false;
        // 清空表单
        this.$refs['form'].resetFields();
        // 重新请求数据
        this.$emit('fetchData');
      } catch (e) {
        window.console.log(e);
      }
    },

    // 编辑
    async edit(dateNotes) {
      try {
        let data =
          'sysMsgId=' +
          this.form.sysMsgId +
          '&content=' +
          this.form.content +
          '&status=' +
          this.form.status +
          '&title=' +
          this.form.title +
          '&dateNotes=' +
          dateNotes;
        // {
        //   sysMsgId: this.form.sysMsgId,
        //   content: this.form.content,
        //   status: this.form.status,
        //   title: this.form.title,
        //   dateNotes: dateNotes,
        // };
        let res = await setSysMsgApi(data);
        if (res.code !== 200) return;
        this.$message.success(this.titleName + '成功!');
        this.dialogFormVisible = false;
        // 清空表单
        this.$refs['form'].resetFields();
        // 重新请求数据
        this.$emit('fetchData');
      } catch (e) {
        window.console.log(e);
      }
    },

    // 点击状态下拉数据
    changeRole(val) {
      this.form.status = val;
    },
  },
};
</script>

<style lang="less" scoped></style>
